<template>
  <div class="achievement">
    <div class="achievement__title">
      <div class="achievement__title__name">ACOrange</div>
      <div class="achievement__title__date">Established in April 2007</div>
    </div>
    <div class="achievement__content">
      <div class="achievement__content__item">
        <div class="achievement__content__item__num">5</div>
        <div class="achievement__content__item__unit">Countries</div>
      </div>
      <div class="achievement__content__item">
        <div class="achievement__content__item__num">90</div>
        <div class="achievement__content__item__unit">Cities</div>
      </div>
      <div class="achievement__content__item">
        <div class="achievement__content__item__num">20000</div>
        <div class="achievement__content__item__unit">Shows</div>
      </div>
    </div>
    <router-link class="achievement__about-us" v-show="$route.path!=='/about-us/brief'" to="/about-us/brief">
      {{ $t("About Us")
      }}<i class="iconfont acog-gengduo achievement__about-us__arrow"></i>
    </router-link>
  </div>
</template>
<script>
export default {
  name:'Achievement'
}
</script>
<style lang="scss" scoped>
.achievement {
  height: 452px;
  background-image: url("../assets/home_bg.png");
  background-position: center;
  padding-top: 56px;
  box-sizing: border-box;
  text-align: center;
  &__title {
    width: 354px;
    color: rgba(254, 254, 254, 1);
    margin: 0 auto;
    &__name {
      font-size: 40px;
      font-weight: 400;
      line-height: 40px;
      height: 44px;
      text-align: center;
    }
    &__date {
      font-size: 30px;
      font-weight: 400;
      margin-top: 10px;
      line-height: 34px;
      height: 34px;
    }
  }
  &__content {
    color: #fefefe;
    text-align: center;
    margin-top: 71px;
    &__item {
      display: inline-block;
      width: 245px;
      &__num {
        font-size: 46px;
        font-weight: bold;
        color: rgba(254, 254, 254, 1);
        line-height: 36px;
        line-height: 36px;
      }
      &__unit {
        margin-top: 19px;
        line-height: 18px;
        line-height: 18px;
        font-size: 22px;
      }
    }
  }
  &__about-us {
    cursor: pointer;
    width: 232px;
    height: 46px;
    border: 1px solid rgba(254, 254, 254, 1);
    border-radius: 23px;
    color: #fefefe;
    margin-top: 65px;
    text-align: center;
    line-height: 46px;
    text-align: center;
    display: inline-block;
    margin: 65px auto 0 auto;
    vertical-align: middle;
    &__arrow {
      font-size: 10px;
      vertical-align: middle;
      margin-left: 2px;
    }
  }
}
</style>